import {makeStyles} from '@material-ui/core/styles';

export default makeStyles(theme => ({
  title: {
    padding: theme.spacing(1),
    marginTop: theme.spacing(1),
    textAlign: 'center'
  },
  paper: {
    padding: theme.spacing(1),
    minHeight: '95%',
  },
  text: {
    textAlign: 'center',
    paddingBottom: theme.spacing(3),
  },
  dialog: {
    padding: theme.spacing(3),
    overflow: 'hidden',
  },
  stats: {
    padding: theme.spacing(2),
    paddingTop: 0,
    marginLeft: `-${theme.spacing(2)}px`
  },
  metaDeliveriesContainer: {
    overflow: 'auto',
    height: '70vh',
  },
}));
